import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  // SiVisualstudiocode, // removed unused
  SiPostman,
  // SiSlack, // removed unused
  SiVercel,
  SiMacos,
  SiHeroku,
  SiGithub,
  SiGit, // Git icon
  SiBun,
  SiGooglecloud,
  SiDocker,
  SiAmazonaws,
  SiArduino,
  SiLinux,
  SiNginx,
  SiKubernetes,
  SiFirebase,
  SiSupabase,
  SiHomebrew, // Homebrew
  SiYarn, // Yarn
  SiVite, // Vite
  SiXcode, // Xcode
  SiNetlify, // Netlify
  SiAzuredevops, // For Azure (more specific than a generic Azure icon)
  SiTrello, // Placeholder for Truffle/Ganache if direct icons are scarce or if used for project management
  SiMeta, // Placeholder for MetaMask
  SiCmake // CMake
} from "react-icons/si";

// Note: Finding exact matches for Ganache, Truffle can be hard. 
// Using placeholders or closely related dev tool icons might be necessary.

function Toolstack() {
  const tools = [
    { icon: <SiGit />, name: "Git" },
    { icon: <SiGithub />, name: "GitHub" },
    { icon: <SiPostman />, name: "Postman" },
    { icon: <SiHeroku />, name: "Heroku" },
    { icon: <SiBun />, name: "Bun" },
    { icon: <SiDocker />, name: "Docker" },
    { icon: <SiAmazonaws />, name: "" },
    { icon: <SiAzuredevops />, name: "Azure" },
    { icon: <SiGooglecloud />, name: "Google Cloud" },
    { icon: <SiLinux />, name: "Linux" },
    { icon: <SiTrello />, name: "Ganache" }, // Placeholder
    { icon: <SiVercel />, name: "Truffle" }, // Placeholder (Vercel for deployment context)
    { icon: <SiMeta />, name: "MetaMask" }, // Placeholder (Meta Platforms icon)
    { icon: <SiArduino />, name: "Arduino" },
    { icon: <SiMacos />, name: "" }, // macOS: Remove text
    { icon: <SiNginx />, name: "Nginx" },
    { icon: <SiKubernetes />, name: "Kubernetes" },
    { icon: <SiFirebase />, name: "Firebase" },
    { icon: <SiSupabase />, name: "Supabase" },
    { icon: <SiCmake />, name: "CMake" },
    { icon: <SiHomebrew />, name: "Homebrew" },
    { icon: <SiYarn />, name: "Yarn" },
    { icon: <SiVite />, name: "Vite" },
    { icon: <SiXcode />, name: "Xcode" },
    { icon: <SiVercel />, name: "Vercel" },
    { icon: <SiNetlify />, name: "Netlify" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, index) => (
        <Col xs={4} md={2} key={index} className="tech-icons">
          {tool.icon}
          {tool.name && <div style={{marginTop: "5px", fontSize: "0.4em"}}>{tool.name}</div>}
      </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
